import { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './index.styles';

const level = 0;

/**
 * Renders navigation.
 */
export default function Nav({ children }) {
  return <Wrapper>{Children.map(children, (child) => cloneElement(child, { level }))}</Wrapper>;
}

Nav.propTypes = {
  /**
   * Navigation content.
   */
  children: PropTypes.node,
};
